import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { HashLink } from "react-router-hash-link";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: { color: "#565553", fontSize: "14px" },
  link: {
    cursor: "pointer",
    fontSize: "13px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  linkCursor: {
    cursor: "pointer",
    paddingBottom: "2px",
    backgroundColor: "#3d3d4f",
    paddingLeft: "20px",
    paddingRight: "20px",
    color: "white",
    fontSize: "13px",
  },
});

const Details = ({ list }) => {
  const { t, i18n } = useTranslation();
  const [index, setIndex] = useState(0);
  const classes = useStyles();
  return (
    <Grid
      className={classes.root}
      sx={{
        mx: { md: 15, sm: 1, xs: 1 },
        pb: 10,
        borderBottom: "1px solid lightgray",
        fontSize: { md: "15px", sm: "12px" },
        pb: 5,
        pt: 12,
      }}
    >
      <Box
        className="textTitle"
        sx={{
          pb: 4,
          fontSize: "17px",
          color: "#424242",
          pt: 6,
        }}
      >
        {t("About This Item")}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          fontSize: "14px",
          borderBottom: "1px solid #3d3d4f",
          flexDirection: { sm: "column", md: "row", xs: "column" },
          backgroundColor: "#f2f5f7",
          // border: "1px solid black",
        }}
      >
        {list.map((data, idx) => {
          if (index === idx) {
            return (
              <Box
                onClick={() => setIndex(idx)}
                key={data.menu}
                className={classes.linkCursor}
                sx={{ py: { sm: "10px", xs: "10px", md: "10px" } }}
              >
                {t(data.menu)}
              </Box>
            );
          }
          return (
            <Box
              onClick={() => setIndex(idx)}
              key={data.menu}
              className={classes.link}
              sx={{ py: { sm: "10px", xs: "10px" } }}
            >
              {t(data.menu)}
            </Box>
          );
        })}
      </Box>
      <Box>
        <ul
          className="normal"
          style={{ fontSize: "14px", lineHeight: "140%", minHeight: "148px" }}
        >
          {/* <li>Free of Ethanol, Benzalkonium, and Isopropanol</li> */}
          {list[index].details.map((detail, idx) => (
            <li key={idx} style={{ paddingTop: "10px", fontSize: "13px" }}>
              {t(detail)}
            </li>
          ))}
        </ul>
      </Box>
    </Grid>
  );
};

export default Details;
